import React from 'react';
import Textarea from "react-textarea-autosize";
import { SocialButton } from "../SocialButton";
import Notifications, { notify } from 'react-notify-toast';
import axios from 'axios';
//TODO: add better toas messages
//TODO: form animations
class Footer extends React.Component {
    constructor() {
        super()
        this.state = {
            sent: false,
            loading: false
        }
        this.handleSubmit = this.handleSubmit.bind(this)
    }
    handleSubmit(e) {
        this.setState({ loading: true });
        e.preventDefault();
        let data = {
            message: e.target.message.value,
            email: e.target.email.value,
            name: e.target.name.value
        };
        data._gotcha = e.target._gotcha.value;
        axios.post('https://formspree.io/dev.adrianmanduc@gmail.com', data, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        }).then((response) => {
            this.setState({ loading: false });
            if (response.data.success && response.data.success === 'email sent') {
                notify.show("Message delivered!", "success", 5000);
                this.form.reset();

            } else {
            }
        }).catch((err) => {
            notify.show("There was an error while sending the message :(", "success", 5000);
            this.setState({ loading: false });
        })
    }
    render() {
        return (
            <div className="footer-wrapper">
                <div className="contact-wrapper">
                    <div className="title">
                        <h3>Contact </h3>
                        <p>Tell me about your project, ask me a question or just say hello</p>
                    </div>
                    <div className="form-wrapper">
                        <form ref={(form) => { this.form = form; }} onSubmit={this.handleSubmit}>
                            <Textarea name="message" required placeholder="Your message*" ref={(messageInput) => { this.messageInput = messageInput; }}></Textarea>
                            {/*                     <div className="input-container">

                        <input className="email" name="email" type="email" />
                        <label className='label' htmlFor="email">Email</label>
                    </div>
                    <input className="name" name="name" placeholder="Your name..." type="text" /> */}
                            <input className="email" required name="email" placeholder="Your email*" type="email" ref={(emailInput) => { this.emailInput = emailInput; }} />
                            <input className="name" required name="name" placeholder="Your name*" type="text" ref={(nameInput) => { this.nameInput = nameInput; }} />
                            <input type="text" name="_gotcha" style={{ display: 'none' }} />
                            <button type="submit">   {!this.state.loading ? 'SEND' : 'LOADING...'}</button>
                        </form>
                        <Notifications />
                    </div>
                    <div className="social-wrapper">
                        <div className="details-wrapper">
                            <span>dev.adrianmanduc@gmail.com</span>
                            <span>+40 724 585978</span>
                        </div>
                        <div className="buttons-wrapper">
                            <SocialButton to="mailto:dev.adrianmanduc@gmail.com?Subject=Hello%20Adrian" target="_self" className="fa fa-envelope"></SocialButton>
                            <SocialButton to="https://www.facebook.com/adriangabriel.manduc" className="fa fa-facebook"></SocialButton>
                            <SocialButton to="https://twitter.com/adrianmanduc" className="fa fa-twitter"></SocialButton>
                            <SocialButton to="https://github.com/adrianmanduc" className="fa fa-github"></SocialButton>
                        </div>
                    </div>
                </div>
                <div className="end">
                    <div className="created-by">Created by me with <span className="heart" >&#10084;</span> <span className="keyboard">a keyboard</span></div>
                    <div className="copyright"> <span> © 2018 <span className="copyright__name">Adrian Manduc</span> - All rights reserved</span></div>
                </div>
            </div >
        );
    }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js